import { STORAGE } from "@constants/Storage";
import { PolicyGroups } from "@constants/Policies";
import { RoleAliases } from "@constants/Roles";
import { PATHS } from "@constants/Paths";
export const getUserContext = () => {
    let userContext = null;
    try {
        const userDetailsString = sessionStorage.getItem(STORAGE.USER_CONTEXT);
        userContext = (userDetailsString && JSON.parse(userDetailsString)) || null;
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
    return userContext;
};
export const storeUserContext = (useContext) => {
    try {
        sessionStorage.setItem(STORAGE.USER_CONTEXT, JSON.stringify(useContext));
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
};
export const isAdminUser = (userContext) => {
    var _a, _b;
    if (userContext) {
        return ((_b = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.user) === null || _a === void 0 ? void 0 : _a.role) === null || _b === void 0 ? void 0 : _b.alias) === "admin";
    }
    return window.location.host.includes("parrots");
};
export const getRedirectPathAfterLogin = (user) => {
    var _a;
    return ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.alias) === "admin" ? `${PATHS.ADMIN}/${PATHS.ADMIN_HOME}/${PATHS.ADMIN_USERS}` : PATHS.HOME;
};
const filterAllowPolicies = (policies, denyPolicies) => {
    return policies.filter((policy) => {
        return !(denyPolicies === null || denyPolicies === void 0 ? void 0 : denyPolicies.some((denyPolicy) => denyPolicy.endsWith(`::${policy}`)));
    });
};
export const generateAllowedPolicies = (userRole, userFeatures, featureGatedPolicies, denyPolicies) => {
    const allowedPolicies = [
        ...userFeatures,
        ...featureGatedPolicies,
        ...filterAllowPolicies(PolicyGroups.ANALYTICS, denyPolicies),
        ...filterAllowPolicies(PolicyGroups.PROSPECT_INTELLIGENCE, denyPolicies),
        ...filterAllowPolicies(PolicyGroups.SCAN_REQUEST, denyPolicies),
    ];
    if (isAdminUser()) {
        allowedPolicies.push(...PolicyGroups.ACCOUNT_HEALTH);
    }
    if (!["basic"].includes(userRole)) {
        allowedPolicies.push("Space_Edit" /* PolicyActions.SPACE_EDIT */, ...PolicyGroups.SGT);
    }
    if (!["agent", "owner", "basic"].includes(userRole)) {
        allowedPolicies.push("accounts_read" /* PolicyActions.ACCOUNTS_READ */, "community_write" /* PolicyActions.COMMUNITY_WRITE */);
    }
    if ([RoleAliases.ORG_ADMIN].includes(userRole)) {
        allowedPolicies.push("Regional Leasing" /* PolicyActions.REGIONAL_LEASING */);
    }
    return allowedPolicies;
};
